import { render, staticRenderFns } from "./FullContentLoader.vue?vue&type=template&id=12b25899&scoped=true"
import script from "./FullContentLoader.vue?vue&type=script&lang=js"
export * from "./FullContentLoader.vue?vue&type=script&lang=js"
import style0 from "./FullContentLoader.vue?vue&type=style&index=0&id=12b25899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b25899",
  null
  
)

export default component.exports